import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import WebLayout from './layouts/WebLayout';
import BillingPage from './pages/BillingPage';
import ClientHandBook from './pages/ClientHandBook';
import ContactInfoPage from './pages/ContactInfoPage';
import DocumentsPage from './pages/DocumentsPage';
import DownloadsPage from './pages/DownloadsPage';
import LoginNew from './pages/LoginNew';
import PrivacyNoticePage from './pages/PrivacyNoticePage';
import SchedulePage from './pages/SchedulePage';
import SubmitRequestPage from './pages/SubmitRequestPage';
import { getToken } from './utils/auth.util';

function App() {
  const token = getToken();

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginNew />
            </PublicRoute>
          }
        />

        <Route path="/privacy-notice" element={<PrivacyNoticePage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <WebLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<SchedulePage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="submit-request" element={<SubmitRequestPage />} />
          <Route path="downloads" element={<DownloadsPage />} />
          <Route path="contact" element={<ContactInfoPage />} />
          <Route path="client-handbook" element={<ClientHandBook />} />
        </Route>

        <Route
          path="*"
          element={token ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />}
        />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;
